import { useQuery } from '@tanstack/react-query';

import { getCountryStates } from '@module/mdrt-org/shared/utils/data';
import { OrgSharedDataTag } from '@module/mdrt-org/shared/utils/data/constants';

export const useCountryStatesQuery = ({
  selectedCountryId,
}: {
  selectedCountryId: number | undefined;
}) => {
  const { data: countryStatesData, isLoading: isCountryStatesDataLoading } = useQuery({
    enabled: Boolean(selectedCountryId),
    queryFn: async () =>
      selectedCountryId ? await getCountryStates({ countryId: selectedCountryId }) : [],
    queryKey: [
      OrgSharedDataTag.GET_COUNTRY_STATES,
      `${OrgSharedDataTag.GET_COUNTRY_STATES}_${selectedCountryId}`,
    ],
  });

  const stateOptions =
    countryStatesData?.map((state) => ({
      label: state.stateName,
      value: state.id,
    })) ?? [];

  return { isCountryStatesDataLoading, stateOptions };
};
